const devBoard = {
  HOME_TOP_BANNER: {
    id: 7,
    summary: '홈 상단 배너',
    alias: 'index_main_banner',
  },
  HOME_SQUARE_BANNER: {
    id: 912,
    summary: '홈 스케쥴 우측 사각형 배너',
    alias: 'index_popup_pc_image1',
  },
  HOME_GRID_BANNER: {
    id: 4,
    summary: '홈 하단 2X2 그리드 공공 배너',
    alias: 'index_main_banner',
  },
  HOME_SLIDE_BANNER: {
    id: 5,
    summary: '홈 하단 슬라이드 공공 배너',
    alias: 'index_main_banner',
  },
  HOME_LINE_BANNER: {
    id: 6,
    summary: '홈 하단 줄 배너',
    alias: 'index_main_banner',
  },
  PC_POPUP_BANNER: {
    id: 919,
    summary: 'PC웹 전용 팝업 배너',
    alias: 'index_popup_pc_image2',
  },
  MO_POPUP_BANNER: {
    id: 913,
    summary: '모바일웹 전용 팝업 배너',
    alias: 'index_popup_mobile_image',
  },
  LIVE_BANNER: {
    id: 16,
    summary: '라이브 편성표 하단 배너',
    alias: 'live_banner',
  },
  RADIO_TOP_BANNER: {
    id: 18,
    summary: '라디오 왼쪽 상단 배너',
    alias: 'main_banner',
  },
  RADIO_MID_BANNER: {
    id: 17,
    summary: '라디오 중간 배너',
    alias: 'main_banner',
  },
  NEWS_BANNER: {
    id: 910,
    summary: '뉴스 컨텐츠/카테고리 사이 배너',
    alias: 'index_main_banner',
  },
};

export default devBoard;
